// extracted by mini-css-extract-plugin
module.exports = {"root":"DataTable_root__xPjJY"};